module.exports = __webpack_public_path__ + "img/xd.40920ad8.svg";